import { Accessor, JSX } from "solid-js";

import { cva } from "styled-system/css";

const baseStyles = cva({
  base: {
    willChange: "transform",
    scrollbarWidth: "none",

    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  variants: {
    direction: {
      x: {
        overflowX: "scroll",
      },
      y: {
        overflowY: "scroll",
      },
    },
  },
  defaultVariants: {
    direction: "y",
  },
});

/**
 * Add styles for an invisible scrollable container
 * @param el Element
 * @param accessor Parameters
 */
export function invisibleScrollable(
  el: HTMLDivElement,
  accessor: Accessor<JSX.Directives["invisibleScrollable"] & object>,
) {
  const props = accessor();
  const options = (props && typeof props === "object" ? props : {}) as any;

  el.classList.add(...baseStyles({ direction: options.direction || "y" }).split(" "));

  if (typeof options.class === "string") {
    options.class.split(" ").forEach((cls: string) => el.classList.add(cls));
  }
}
